<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addInvoicingInformation')"
        :rules="rulesCooperatorContact"
        :submit="submit"
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="formData.companyName"
                :label="$t('labels.companyName')"
                required
                prop="companyName"
                name="companyName" />

            <hts-form-input
                v-model="formData.phone"
                :label="$t('labels.phone')"
                prop="phone"
                name="phone" />

            <hts-form-input
                v-model="formData.address"
                :label="$t('labels.address')"
                prop="address"
                name="address" />

            <hts-form-input
                v-model="formData.email"
                :label="$t('labels.email')"
                prop="email"
                name="email" />

            <hts-form-input
                v-model="formData.taxNumber"
                :label="$t('labels.taxNumber')"
                prop="taxNumber"
                name="taxNumber" />

            <hts-form-input
                v-model="formData.contactName"
                :label="$t('labels.contactName')"
                prop="contactName"
                name="contactName" />
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import data from '../ignore/data'
const { departments } = data()

const rulesCooperatorContact = {
  companyName: 'required'
}

const cooperatorId = ref('')
const visible = ref(false)

const resetForm = () => {
  formData.value = {
    companyName: '',
    phone: '',
    address: '',
    email: '',
    taxNumber: '',
    contactName: ''
  }
}
const formData = ref({
  companyName: '',
  phone: '',
  address: '',
  email: '',
  taxNumber: '',
  contactName: ''
})
const close = () => {
  resetForm()
  visible.value = false
}

const emits = defineEmits(['update:show', 'close', 'refreshTables', 'newData'])

const open = (id: string) => {
  cooperatorId.value = id
  visible.value = true
}

defineExpose({
  open
})

const submit = async () => {
  const api = {
    url: '/partner/invoicing-information/cooperatorId/create',
    method: 'post'
  }

  const data: any = await $api(api, { uriParams: { cooperatorId: cooperatorId.value }, body: formData.value })
  const resData = data?.data?.value

  if (resData && resData.success) {
    if (resData.success) {
      resetForm()
      process.client && $toast().success($t('labels.addSuccess'))
      close()
      emits('refreshTables')
      emits('newData', resData.data)
    }
  }
}
</script>
